// test695
(695 && 0);
